import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'




export default {
  name: 'ventasPagosPorMes',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      meses: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ],
      annos: [],
      comercios_f: [],
      f_c: {
        mes: 0,
        anno: 0,
        estado: false
      },
      tabla: {
        meses: [],
        data: []
      }
    }
  },
  mounted() {
    let anioActual = new Date().getFullYear();
    this.annos = [anioActual - 1, anioActual];

    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return '/SERVER/scd/excel/?dsis=' + window.sssdi + '&a=ventasPorMes' + '&mes=' + this.f_c.mes + '&anno=' + this.f_c.anno

    }
  },
  methods: {
    descargar() {
      this.to_excel_name2($("#dett").html(), 'dett', 'Ventas – Pagos por mes ');
    },
    consultar() {
      if (this.f_c.mes != 0 && this.f_c.anno != 0) {
        this.loading = true;
        this.$http
          .post('/SERVER/scd/estadisticas/', {
            'a': 'ventasPagosPorMes',
            'f': this.f_c
          }, {
            withCredentials: true
          })
          .then(response => {
            if (response.data.status == 1) {
              this.tabla.meses = response.data.meses;
              let totales = ["Totales", 0.0];
              for (let i = 0; i < response.data.meses.length; i++) {
                totales.push(0.0);
              }
              for (let i = 0; i < response.data.data.length; i++) {
                for (let h = 1; h < response.data.data[i].length; h++) {
                  if (response.data.data[i][h] != null) {
                    totales[h] += parseFloat(response.data.data[i][h]);
                  }
                }
              }
              response.data.data.push(totales);
              for (let i = 0; i < response.data.data.length; i++) {
                for (let d = 1; d < response.data.data[i].length; d++) {
                  if (response.data.data[i][d] != null) {
                    response.data.data[i][d] = this.num_to_many(parseFloat(response.data.data[i][d]).toFixed(2));
                  }
                }
              }
              this.tabla.data = response.data.data;
            }
            this.loading = false;
          });
      } else {
        this.showNotification({
          msj: "Verifique que los campos Mes y Año se encuentren cargados",
          bg: 'bg-red'
        });
      }
    },

  }

}



// WEBPACK FOOTER //
// ./src/components/estadisticas/ventasPagosPorMes/index.js